<template>
  <div id="proposta_passo1">
    <el-row type="flex">
      <el-col :span="24" style="text-align:right">
        <el-button
          style="margin-top: 12px; text-align: left;"
          type="primary"
          size="small"
          round
          plain
          @click="anterior"
          :disabled="disable_left"
        >
          <i class="el-icon-d-arrow-left"></i> Anterior
        </el-button>
        <el-button
          style="margin-top: 12px;"
          type="primary"
          plain
          round
          size="small"
          @click="next"
          :disabled="disable_right"
        >
          Próximo
          <i class="el-icon-d-arrow-right"></i>
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="proposta_titulo proposta_centro">Passo 1 - Proposta Comercial</el-col>
    </el-row>
    <el-form :model="ruleForm" :rules="ruleForm" ref="ruleForm">
      <el-row>
        <el-col :span="24">
                    <p class="proposta_titulo">Proposta Comercial</p>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo">
          <el-input v-model="ruleForm.titulo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo">
              <el-input v-model="ruleForm.subtitulo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label prop="proposta">
            <vue-editor id="proposta" v-model="ruleForm.proposta" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <p class="proposta_titulo">Assinatura 1:</p>
          <el-form-item label prop="comercial">
            <vue-editor id="comercial" v-model="ruleForm.comercial" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <p class="proposta_titulo">Assinatura 2:</p>
          <el-form-item label prop="tecnico">
            <vue-editor id="tecnico" v-model="ruleForm.tecnico" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    {{proposta_id}}
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";

export default {
  components: {
    VueEditor,
  },
  props: {
    proposta_id: [Number],
  },
  data() {
    return {
      customToolbar: [
      ["bold", "italic", "underline","strike"],
      [{ list: "ordered" }, { list: "bullet" }]
    ],
      disable_left: false,
      disable_right: false,
      ruleForm: {
        titulo:"",
        subtitulo:"",
        proposta: "",
        comercial: "",
        tecnico: "",
        versao: 3, //buscar a versao de acordo com o orçamento
      },
    };
  },
  mounted() {
    //se não tiver salvo o rascunho ainda então busca os dados da configuração
    if (this.proposta_id == 0) {
   // alert("monta dados" + this.proposta_id);
      let dados = {
        tipo: "P;AP",
      };
      axios
        .post(url + "/textos/proposta/", dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
           
            this.ruleForm.titulo = resp.data[0].titulo;
            this.ruleForm.subtitulo = resp.data[0].subtitulo;
            this.ruleForm.proposta = resp.data[0].texto;
            this.ruleForm.comercial = resp.data[1].texto;
            this.ruleForm.tecnico = resp.data[2].texto;
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });
    } else { //se já tiver rascunho salvo busca dados da propostaGerada
   // alert("monta dadosss" + this.proposta_id);
      let dados = {
        pagina_pagina: "1",
      };
      axios
        .post(url + "/proposta/"+this.proposta_id, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            for(let i=0;i<resp.data['pagina'].length;i++){
              switch(resp.data['pagina'][i].slug){
                case 'titulo': this.ruleForm.titulo = resp.data['pagina'][i].texto; break;
                case 'subtitulo': this.ruleForm.subtitulo = resp.data['pagina'][i].texto; break;
                case 'proposta': this.ruleForm.proposta = resp.data['pagina'][i].texto; break;
                case 'supervisor': this.ruleForm.comercial = resp.data['pagina'][i].texto; break;
                case 'tecnico': this.ruleForm.tecnico = resp.data['pagina'][i].texto; break;
              }
            }
            
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });
    }
  },

  methods: {
    anterior(){
      let prop;
      prop = this.proposta_id;
      let dado = {
        active: 0,
        proposta: prop,
      };
      this.$emit("button-click", dado);
    },

    next() {
      let dados = {
        proposta_id: this.proposta_id,
        proposta_projeto_id: this.$route.params.id,
        proposta_versao: this.ruleForm.versao,
        proposta_status: "R",
        pagina_paginaTipo: "A",
        pagina_pagina: "1",
        ///ordem dos dados = texto*ordem*slug*label*tipo //campos separados por * e mais campos por |
        pagina_dados: this.ruleForm.titulo+'*1*titulo*titulo proposta*TP|'+this.ruleForm.subtitulo+'*2*subtitulo*Sub Titulo Proposta*TP|'+this.ruleForm.proposta+'*1*proposta*PROPOSTA COMERCIAL*P|'+this.ruleForm.comercial+'*1*supervisor*Supervisor Comercial*AP|'+this.ruleForm.tecnico+'*2*tecnico*Responsável Técnico*AP',
        
      };
      axios
        .post(url + "/proposta/register/", dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          this.$notify({
            title: "Sucesso",
            message: "Registro salvo com Sucesso!",
            type: "success",
          });

          let prop;

          if(resp.data.original  === 'undefined'){
            prop = resp.data.original.proposta.id;
          } else {
            prop = resp.data["proposta"].id;
          }
          let dado = {
            active: 2,
            proposta: prop,
          };
          this.$emit("button-click", dado);
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });
    },
  },
};
</script>

<style>
#proposta_passo1 #proposta {
  height: 200px;
  width: 100%;
}
.proposta_titulo {
  text-align: left;
  font-weight: bold;
}
.proposta_centro {
  text-align: center;
}
</style>